'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var tslib = require('tslib');
var styled = require('styled-components');
var variants$1 = require('../variants-434e0406.js');
var variants = require('../variants-096bd30b.js');
require('../lib-75591456.js');
require('../index-6f152094.js');
require('classnames');
require('@prisjakt/design-tokens/light-theme-colors');
require('@prisjakt/design-tokens/measurements-raw');
require('../definitions-4ae1604d.js');
require('../index-105ce710.js');
require('../utils-eb39d0ac.js');
require('../env-100217af.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledPanel = styled__default["default"](variants.Column).attrs(function (p) { return ({
    gap: p.gap || 1,
}); }).withConfig({ displayName: "StyledPanel", componentId: "-w2npmg" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject([""], [""])));
var PanelHeader = styled__default["default"](variants.Row).attrs(function (p) { return ({ gap: p.gap || 0.5 }); }).withConfig({ displayName: "PanelHeader", componentId: "-k52e9f" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  align-items: baseline;\n\n  > *:first-child {\n    flex: 0 1 auto;\n  }\n"], ["\n  align-items: baseline;\n\n  > *:first-child {\n    flex: 0 1 auto;\n  }\n"])));
var PanelTitle = styled__default["default"](variants$1.H3Text).withConfig({ displayName: "PanelTitle", componentId: "-1knopf6" })(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3;

function Panel(props) {
    var children = props.children, className = props.className, container = props.container, containerProps = props.containerProps, style = props.style;
    return (React__default["default"].createElement(StyledPanel, { className: className, style: style, containerProps: containerProps, container: container }, children));
}

exports.Panel = Panel;
exports.PanelHeader = PanelHeader;
exports.PanelTitle = PanelTitle;
//# sourceMappingURL=index.js.map
